import { render, staticRenderFns } from "./creditCenter.vue?vue&type=template&id=2cb7fea4&scoped=true&"
import script from "./creditCenter.vue?vue&type=script&lang=js&"
export * from "./creditCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7fea4",
  null
  
)

export default component.exports